import { Paper, Typography } from "@material-ui/core"
import SnackContext from "@root/components/Snackbar"
import { RootState } from "@root/store"
import React from "react"
import { useSelector } from "react-redux"
import { useSettingStyles } from "../styles"
import AssociatedIdentifiers from "./AssociatedIdentifiers"

const Analytics: React.FC = () => {
  const classes = useSettingStyles()
  const { error } = useSelector((state: RootState) => state.channel)
  const { createSnack } = React.useContext(SnackContext)

  React.useEffect(() => {
    if (error) {
      createSnack(error)
    }
  }, [error])

  return (
    <>
      <Paper
        className={classes.paper}
        data-qa-selector="analytics-associated-identifiers"
      >
        <Typography variant="h4">Associated Identifiers</Typography>
        <AssociatedIdentifiers />
      </Paper>
    </>
  )
}

export default Analytics
